import React, {Component} from 'react';
import Header from "../header";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import {RadioButton, RadioButtonGroup} from 'material-ui/RadioButton';
import RaisedButton from 'material-ui/RaisedButton';
import Footer from "../footer";
import sfotokapak from '../assets/img/sfotokapak.png';
import Tual from "./small/tual";
import PhotoBlock from "./small/photoBlock";
import Printing from "./small/printing";
import loader from './../assets/img/Eclipse.gif';
import Snackbar from 'material-ui/Snackbar';
import { Link } from 'react-router-dom';
import DatePicker from 'material-ui/DatePicker';

const styles = {
  successColor: {
    color: "#696969",
  },
  errorColor: {
    color: "#F44336"
  },
};

class Order extends Component {

  constructor(props) {
    super(props);

    this.state = {
      value: 1,
      orderType: "",
      order_id: null,
      submitClicked: false,
      backButtonError: true,
      orderGiven: false,

      // Albüm Tipi
      albumValue: null,
      albumError: true,
      albumRightValue: "",

      // Sayfa Sayısı
      checkPageNumber: false,
      pageNumber: 1,
      pageNumberError: false,

      // Kapak Modeli
      coverModelValue: null,
      coverModelError: true,
      coverRightModelValue: "",


      // Albüm Ebatı
      albumEbatValue: null,
      albumEbatError: true,
      albumRightEbatValue: "",

      // panoramik sayısı
      panoramikLength: 0,

      // Albüm Sıralama - Checkbox
      albumRankingValue: "Sıralı",

      // Aile Albümü
      albumFamilyValue: 0,
      checkFamilyAlbum: false,
      familyAlbumVal: 0,
      familyAlbumError: false,


      // Hediye Foto
      albumGiftPhotoValue: "",
      checkAlbumGiftPhotoValue: false,
      albumGiftPhotoError: false,

      // Hediye Tual
      albumGiftTualValue: "",
      albumGiftTualError: false,

      // Hediye Foto 2
      albumGiftPhotoValue2: "",
      checkAlbumGiftPhotoValue2: false,
      albumGiftPhotoError2: false,

      // Hediye Tual 2
      albumGiftTualValue2: "",
      albumGiftTualError2: false,

      // Hediye Foto 3
      albumGiftPhotoValue3: "",
      checkAlbumGiftPhotoValue3: false,
      albumGiftPhotoError3: false,

      // Hediye Tual 3
      albumGiftTualValue3: "",
      albumGiftTualError3: false,

      // Açıklama
      albumDescription: "",

      // Submit
      isSubmit: false,

      // panoramik-album-ebat
      panoramikAlbumEbat: null,
      panoramikAlbumEbat2: null,
      panoramikAlbumEbat3: null,
      brideName: '',
      fulldate: null,

      // School

      schoolAlbumEbatValue: null,
      schoolAlbumEbatRightValue: null,

      // Sayfa sayısı
      schoolAlbumFamilyValue: 0,
      schoolCheckFamilyAlbum: false,
      schoolFamilyAlbumVal: 0,
      schoolFamilyAlbumError: false,

      // Okul - normal girdiler
      schoolStudentNumber: 0,
      schoolStudentNumber2: 0,
      schoolDescription: "",

      // Okul - Takvim Ebatı

      schoolCalendarDimensionValue: null,
      schoolCalendarDimensionNumber: 0,


      // Photo Close
      isPhotoShow: false,

      // Özel Albüm ebatı
      specialAlbumValue: null,


      // TUAL

      tualArray: [],
      tualObj: {},
      tualDesc: "",

      // FotoBlok

      photoBlockArray: [],
      photoBlockObj: {},
      photoBlockDesc: "",

      // Printing

      printingArray: [],
      printingObj: {},
      printingDesc: "",

      // Snackbar
      open: false,
      submitMessage: "",
    }
  }

  snackbarClose = () => {
    this.setState({
      open: false,
    });
  };

  handleChange(event, index, value) {
    this.setState({
      value: value,
      orderType: event.target.innerText
    });
  }

  albumValueChange(event, index, value) {
    this.setState({
      albumValue: value,
      albumRightValue: event.target.innerText,
      albumError: false,
    })
  }

  coverValueChange(event, index, value) {
    this.setState({
      coverModelValue: value,
      coverRightModelValue: event.target.innerText,
      coverModelError: false,
      isPhotoShow: false,
    });

    setTimeout(() => {
      this.setState({
        isPhotoShow: true,
      });
    }, 300);
  }

  albumEbatChange(event, index, value) {
    this.setState({
      albumEbatValue: value,
      albumRightEbatValue: event.target.innerText,
      albumEbatError: false,
      coverRightModelValue: '',
      coverModelValue: ''
    })
  }

  pageNumberChange(e) {

    if (e.target.value.length > 0 && e.target.value >= 0 && e.target.value <= 25) {
      this.setState({
        pageNumberError: false,
      })
    } else {
      this.setState({
        pageNumberError: true,
      })
    }

    this.setState({
      pageNumber: e.target.value,
      checkPageNumber: true
    })
  }

  familyAlbumChange(e) {

    if (e.target.value.length > 0 && e.target.value >= 0 && e.target.value <= 25) {
      this.setState({
        familyAlbumError: false,
      })
    } else {
      this.setState({
        familyAlbumError: true,
      })
    }

    this.setState({
      familyAlbumVal: e.target.value,
      checkFamilyAlbum: true
    })
  }

  giftPhotoChange(e) {

    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftPhotoValue: newValue,
      checkAlbumGiftPhotoValue: true,
    })
  }

  giftTualChange(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftTualValue: newValue,
    })
  }

  giftPhotoChange2(e) {

    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftPhotoValue2: newValue,
      checkAlbumGiftPhotoValue2: true,
    })
  }

  giftTualChange2(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftTualValue2: newValue,
    })
  }

  giftPhotoChange3(e) {

    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftPhotoValue3: newValue,
      checkAlbumGiftPhotoValue3: true,
    })
  }

  giftTualChange3(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      albumGiftTualValue3: newValue,
    })
  }

  albumRankingChange(e) {

    if (parseInt(e.target.value, 10) === 1) {
      this.setState({
        albumRankingValue: "Sıralı",
      })
    } else {
      this.setState({
        albumRankingValue: "Sırasız",
      })
    }
  }

  descChange(e) {
    this.setState({
      albumDescription: e.target.value,
    })
  }

  orderSubmit(e) {
    e.preventDefault();

    let orderid = null;
    let companyName = localStorage.getItem("companyName");

    this.setState({
      submitClicked: true,
    });

    fetch("https://saydamalbum.com/saydamWebservice/getLastOrder.php", {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
    }).then((response) => {
      return response.json();
    }).then((data) => {
      let isDataFull = false;

      if (data.data === "null") {
        orderid = 0;
        isDataFull = true;
      } else {
        orderid = data.data["o_orderID"];
      }

      this.setState({
        order_id: orderid
      });

      if (data.responseType === 200 || isDataFull) {
        if (this.state.value === 2) { // Album

          let familyAlbumEbatValue = null;
          if ((this.state.albumEbatValue === 3)) {
            familyAlbumEbatValue = this.state.panoramikAlbumEbatText;
          } else if ((this.state.albumEbatValue === 5)) {
            familyAlbumEbatValue = this.state.panoramikAlbumEbat2Text;
          } else if ((this.state.albumEbatValue === 6)) {
            familyAlbumEbatValue = this.state.panoramikAlbumEbat3Text;
          } else if ((this.state.albumEbatValue === 1)) {
            familyAlbumEbatValue = "15x25";
          } else if ((this.state.albumEbatValue === 2)) {
            familyAlbumEbatValue = "15x30";
          } else if ((this.state.albumEbatValue === 4)) {
            familyAlbumEbatValue = "20x50";
          } else if ((this.state.albumEbatValue === 7)) {
            familyAlbumEbatValue = "25x50";
          } else if ((this.state.albumEbatValue === 8)) {
            familyAlbumEbatValue = "20x47";
          } else if ((this.state.albumEbatValue === 10)) {
            familyAlbumEbatValue = "20x50";
          }

          let body = (
            "orderType=" + this.state.value
            + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10))
            + "&orderName=" + this.state.orderType
            + "&albumEbat=" + this.state.albumRightEbatValue
            + "&albumNumber=" + this.state.panoramikLength
            + "&familyAlbumEbat=" + familyAlbumEbatValue
            + "&familyAlbumNumber=" + this.state.familyAlbumVal
            + "&albumType=" + this.state.albumRightValue
            + "&pageNumber=" + this.state.pageNumber
            + "&coverModel=" + this.state.coverRightModelValue
            + "&albumOrder=" + this.state.albumRankingValue
            + "&printingEbat=" + this.state.albumGiftPhotoValue
            + "&tualEbat=" + this.state.albumGiftTualValue
            + "&printingEbat2=" + this.state.albumGiftPhotoValue2
            + "&tualEbat2=" + this.state.albumGiftTualValue2
            + "&printingEbat3=" + this.state.albumGiftPhotoValue3
            + "&tualEbat3=" + this.state.albumGiftTualValue3
            + "&companyName=" + localStorage.getItem("companyName")
            + "&companyMail=" + localStorage.getItem("companyMail")
          );

          console.log('BEFORE:', body);

          if (this.state.brideName) {
            body += "&brideName=" + encodeURIComponent(this.state.brideName);
          } else {
            body += "&brideName=''"; 
          }

          if (this.state.albumDescription) {
            body += "&description=" + encodeURIComponent(this.state.albumDescription);
          } else {
            body += "&description=''";
          }

          if (this.state.fulldate) {
            body += "&eventDate=" + this.state.fulldate;
          } else {
            body += "&eventDate=''";
          }

          console.log(body, this.state);

          fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: body
          }).then((response) => {
            return response.json();
          }).then((data) => {
            this.setState({
              open: true,
              submitMessage: data.responseMessage,
              submitClicked: false,
            });

            if (data.responseType === 200) {
              this.setState({
                isSubmit: true,
                orderGiven: true,
                backButtonError: false,
              });
            }
          });
        }
        else if (this.state.value === 3) { // Okul

          let studentNumber = 0;
          if (!(this.state.schoolAlbumEbatValue === 8 || this.state.schoolAlbumEbatValue === 9 || this.state.schoolAlbumEbatValue === 10)) {
            studentNumber = this.state.schoolStudentNumber;
          } else {
            studentNumber = this.state.schoolStudentNumber2;
          }

          let body2 = (
            "orderType=" + this.state.value
            + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10))
            + "&orderName=" + this.state.orderType
            + "&albumEbat=" + this.state.schoolAlbumEbatRightValue
            + "&pageNumber=" + this.state.schoolFamilyAlbumVal
            + "&studentNumber=" + studentNumber
            + "&calendarEbat=" + this.state.schoolCalendarDimensionValue
            + "&calendarNumber=" + this.state.schoolCalendarDimensionNumber
            + "&companyName=" + localStorage.getItem("companyName")
            + "&companyMail=" + localStorage.getItem("companyMail")
          );

          if (this.state.schoolDescription) {
            body2 += "&description=" + encodeURIComponent(this.state.schoolDescription);
          } else {
            body2 += "&description=''";
          }

          fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
            method: 'POST',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
            },
            body: body2
          }).then((response) => {
            return response.json();
          }).then((data) => {

              this.setState({
                open: true,
                submitMessage: data.responseMessage,
                submitClicked: false,
              });

              if (data.responseType === 200) {
                this.setState({
                  isSubmit: true,
                  orderGiven: true,
                  backButtonError: false,

                });
              }
            }
          );

        }
        else if (this.state.value === 4) { // Tual
          if (Object.keys(this.state.tualObj).length === 0) {
            this.setState({
              open: true,
              submitMessage: "LÜTFEN EKLE BUTONUNA BASTIĞINIZDAN EMİN OLUNUZ.",
              submitClicked: false,
            })
          } else {
            for (let item in  Object.keys(this.state.tualObj)) {
              let ebat = this.state.tualObj[item].ebatValue;
              let number = this.state.tualObj[item].tualNumber;

              let body = (
                "orderType=" + this.state.value
                + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10) + parseInt(item, 10))
                + "&orderName=" + this.state.orderType
                + "&companyName=" + localStorage.getItem("companyName")
                + "&companyMail=" + localStorage.getItem("companyMail")
                + "&ebat=" + ebat
                + "&number=" + number
              );

              if (this.state.tualDesc) {
                body += "&description=" + encodeURIComponent(this.state.tualDesc);
              } else {
                body += "&description=''";
              }

              fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: body
              }).then((response) => {
                return response.json();
              }).then((data) => {
                this.setState({
                  open: true,
                  submitMessage: data.responseMessage,
                  submitClicked: false,
                });

                if (data.responseType === 200) {
                  this.setState({
                    isSubmit: true,
                    orderGiven: true,
                    backButtonError: false,
                  });
                }
              });
            }
          }
        }
        else if (this.state.value === 5) { // Fotoblok
          if (Object.keys(this.state.photoBlockObj).length === 0) {
            this.setState({
              open: true,
              submitMessage: "LÜTFEN EKLE BUTONUNA BASTIĞINIZDAN EMİN OLUNUZ.",
              submitClicked: false,
            })
          } else {
            for (let item in  Object.keys(this.state.photoBlockObj)) {
              let ebat = this.state.photoBlockObj[item].ebatValue;
              let number = this.state.photoBlockObj[item].photoBlockNumber;

              let body = (
                "orderType=" + this.state.value
                + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10) + parseInt(item, 10))
                + "&orderName=" + this.state.orderType
                + "&companyName=" + localStorage.getItem("companyName")
                + "&companyMail=" + localStorage.getItem("companyMail")
                + "&ebat=" + ebat
                + "&number=" + number
              );

              if (this.state.photoBlockDesc) {
                body += "&description=" + encodeURIComponent(this.state.photoBlockDesc);
              } else {
                body += "&description=''";
              }
              

              fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: body
              }).then((response) => {
                return response.json();
              }).then((data) => {
                this.setState({
                  open: true,
                  submitMessage: data.responseMessage,
                  submitClicked: false,
                });

                if (data.responseType === 200) {
                  this.setState({
                    isSubmit: true,
                    orderGiven: true,
                    backButtonError: false,

                  });
                }
              });
            }
          }
        }
        else if (this.state.value === 6) { // Baskı
          if (Object.keys(this.state.printingObj).length === 0) {
            this.setState({
              open: true,
              submitMessage: "LÜTFEN EKLE BUTONUNA BASTIĞINIZDAN EMİN OLUNUZ.",
              submitClicked: false,
            })
          } else {
            for (let item in  Object.keys(this.state.printingObj)) {
              let ebat = this.state.printingObj[item].ebatValue;
              let number = this.state.printingObj[item].printingNumber;

              let body = (
                "orderType=" + this.state.value
                + "&orderID=" + (parseInt(orderid, 10) + parseInt(1, 10) + parseInt(item, 10))
                + "&orderName=" + this.state.orderType
                + "&companyName=" + localStorage.getItem("companyName")
                + "&companyMail=" + localStorage.getItem("companyMail")
                + "&ebat=" + ebat
                + "&number=" + number
              );
    
              if (this.state.printingDesc) {
                body += "&description=" + encodeURIComponent(this.state.printingDesc);
              } else {
                body += "&description=''";
              }
        
              fetch("https://saydamalbum.com/saydamWebservice/giveorder.php", {
                method: 'POST',
                headers: {
                  'Accept': 'application/json',
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                },
                body: body 
              }).then((response) => {
                return response.json();
              }).then((data) => {
                console.log(data);
                this.setState({
                  open: true,
                  submitMessage: data.responseMessage,
                  submitClicked: false,
                });

                if (data.responseType === 200) {
                  this.setState({
                    isSubmit: true,
                    orderGiven: true,
                    backButtonError: false,
                  });
                }
              });
            }
          }

        }
      }
    });
  }

  datePickerChange(param1, date) {
    let fulldate = date.getFullYear() + "-" + parseInt(date.getMonth() + 1, 10) + "-" + date.getDate();

    this.setState({
        datePickerValue: date,
        fulldate: fulldate,
    });
    console.log(fulldate, date);
  }

  // Babam edit

  panoramikAlbumEbatChange(event, index, value) {
    this.setState({
      panoramikAlbumEbat: value,
      panoramikAlbumEbatText: event.target.innerText,
    })
  }

  panoramikAlbumEbatChange2(event, index, value) {
    this.setState({
      panoramikAlbumEbat2: value,
      panoramikAlbumEbat2Text: event.target.innerText,
    })
  }


  panoramikAlbumEbatChange3(event, index, value) {
    this.setState({
      panoramikAlbumEbat3: value,
      panoramikAlbumEbat3Text: event.target.innerText,
    })
  }


  schoolAlbumEbatChange(event, index, value) {
    this.setState({
      schoolAlbumEbatValue: value,
      schoolAlbumEbatRightValue: event.target.innerText,
    })
  }

  schoolFamilyAlbumChange(e) {
    if (e.target.value.length > 0 && e.target.value >= 0 && e.target.value <= 20) {
      this.setState({
        schoolFamilyAlbumError: false,
      })
    } else {
      this.setState({
        schoolFamilyAlbumError: true,
      })
    }

    this.setState({
      schoolFamilyAlbumVal: e.target.value,
      schoolCheckFamilyAlbum: true
    })
  }


  specialAlbumDimension(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      specialAlbumValue: newValue,
    })
  }

  schoolCalendarDimension(e) {
    let newValue = this.findDimensions(e.target.value);
    this.setState({
      schoolCalendarDimensionValue: newValue,
    })
  }

  schoolCalendarDimensionNumber(e) {
    this.setState({
      schoolCalendarDimensionNumber: e.target.value,
    })
  }


  tualAlbumEbatChange(ebatValue, ebatRightValue, key, tualNumberVal) {

    let tualObj = Object.assign({}, this.state.tualObj);
    tualObj[key] = {
      ebatValue: ebatRightValue,
      tualNumber: tualNumberVal,
    };
    this.setState({
      tualObj,
    });

  }


  tualOrderSize(e) {
    if (e.target.value < 20) {

      let tualArray = [];

      for (let i = 0; i < parseInt(e.target.value, 10); i++) {
        tualArray.push(<Tual key={i} data={this.state.tualObj} number={i}
                             onChange1={this.tualAlbumEbatChange.bind(this)}/>);
      }

      this.setState({
        tualArray: tualArray,
      })
    }
  }


  photoBlockEbatChange(ebatRightValue, key, numberVal) {

    let photoBlockObj = Object.assign({}, this.state.photoBlockObj);
    photoBlockObj[key] = {
      ebatValue: ebatRightValue,
      photoBlockNumber: numberVal,
    };
    this.setState({
      photoBlockObj,
    });

  }

  photoBlockOrderSize(e) {
    if (e.target.value < 20) {

      let photoBlockArray = [];

      for (let i = 0; i < parseInt(e.target.value, 10); i++) {
        photoBlockArray.push(<PhotoBlock key={i} number={i}
                                         onChange1={this.photoBlockEbatChange.bind(this)}/>);
      }

      this.setState({
        photoBlockArray: photoBlockArray,
      })
    }
  }


  printingEbatChange(ebatValue, ebatRightValue, key, numberVal) {

    let printingObj = Object.assign({}, this.state.printingObj);
    printingObj[key] = {
      ebatValue: ebatRightValue,
      printingNumber: numberVal,
    };
    this.setState({
      printingObj,
    });

  }


  printingOrderSize(e) {
    if (e.target.value < 20) {

      let printingArray = [];

      for (let i = 0; i < parseInt(e.target.value, 10); i++) {
        printingArray.push(<Printing key={i} data={this.state.printingObj} number={i}
                                     onChange1={this.printingEbatChange.bind(this)}/>);
      }

      this.setState({
        printingArray: printingArray,
      })
    }
  }

  backOrder() {
    if (this.state.value === 2) {
      fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: "orderType=" + this.state.value
        + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(1, 10))
      }).then((response) => {
        return response.json();
      }).then((data) => {
        this.setState({
          submitMessage: data.responseMessage,
          open: true,
        });

        if (data.responseType === 200) {
          setTimeout(() => {
            this.setState({
              isSubmit: false,
              submitClicked: false,
              orderGiven: false,
              backButtonError: true,
            });
          }, 1500);
        }
      });
    } else if (this.state.value === 3) {
      fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        },
        body: "orderType=" + this.state.value
        + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(1, 10))
      }).then((response) => {
        return response.json();
      }).then((data) => {

        this.setState({
          submitMessage: data.responseMessage,
          open: true,
        });

        if (data.responseType === 200) {
          setTimeout(() => {
            this.setState({
              isSubmit: false,
              submitClicked: false,
              orderGiven: false,
              backButtonError: true,
            });
          }, 1500);
        }
      });
    } else if (this.state.value === 4) { // Tual
      for (let i = this.state.tualArray.length - 1; i >= 0; i--) {
        fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: "orderType=" + this.state.value
          + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(this.state.tualArray.length, 10) - parseInt(i, 10))
        }).then((response) => {
          return response.json();
        }).then((data) => {

          this.setState({
            submitMessage: data.responseMessage,
            open: true,
          });

          if (data.responseType === 200) {

            setTimeout(() => {
              this.setState({
                isSubmit: false,
                submitClicked: false,
                orderGiven: false,
                backButtonError: true,
              });
            }, 1500);
          }
        });
      }
    } else if (this.state.value === 5) {
      for (let i = this.state.photoBlockArray.length - 1; i >= 0; i--) {
        fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: "orderType=" + this.state.value
          + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(this.state.photoBlockArray.length, 10) - parseInt(i, 10))
        }).then((response) => {
          return response.json();
        }).then((data) => {

          this.setState({
            submitMessage: data.responseMessage,
            open: true,
          });

          if (data.responseType === 200) {
            setTimeout(() => {
              this.setState({
                isSubmit: false,
                submitClicked: false,
                orderGiven: false,
                backButtonError: true,
              });
            }, 1500);
          }
        });
      }
    } else if (this.state.value === 6) {
      for (let i = this.state.printingArray.length - 1; i >= 0; i--) {

        fetch("https://saydamalbum.com/saydamWebservice/orderdelete.php", {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
          },
          body: "orderType=" + this.state.value
          + "&orderID=" + (parseInt(this.state.order_id, 10) + parseInt(this.state.printingArray.length, 10) - parseInt(i, 10))
        }).then((response) => {
          return response.json();
        }).then((data) => {

          this.setState({
            submitMessage: data.responseMessage,
            open: true,
          });

          if (data.responseType === 200) {
            setTimeout(() => {
              this.setState({
                isSubmit: false,
                submitClicked: false,
                orderGiven: false,
                backButtonError: true,
              });
            }, 1500);
          }
        });
      }
    }
  }

  findDimensions(e) {
    let x = e.replace(/\D/g, '').match(/(\d{0,2})(\d{0,3})/);
    e = !x[2] ? x[1] : '' + x[1] + 'x' + x[2] + (x[3] ? '' + x[3] : '');

    return e;
  }

  render() {
    let pageNumberErrorMessage = "";
    if (this.state.pageNumberError) {
      pageNumberErrorMessage = this.state.checkPageNumber ? "Lütfen 0 ile 25 arası sayfa sayısı giriniz" : "";
    }

    let familyAlbumErrorMessage = "";
    if (this.state.familyAlbumError) {
      familyAlbumErrorMessage = this.state.checkFamilyAlbum ? "Lütfen 0 ile 25 arası sayfa sayısı giriniz" : "";
    }

    let rndNumber = 0;
    if (this.state.isSubmit) {
      rndNumber = Math.floor(Math.random() * 1000);
    }

    let schoolFamilyAlbumErrorMessage = "";
    if (this.state.schoolFamilyAlbumError) {
      schoolFamilyAlbumErrorMessage = this.state.schoolCheckFamilyAlbum ? "Lütfen 0 ile 20 arası sayfa sayısı giriniz" : "";
    }

    let tual = this.state.tualObj;
    let newTual = [];
    for (let prop in tual) {
      newTual.push(tual[prop]);
    }


    return (
      <div>
        <Header/>

        <main className="order-page">
          <div className="container">
            {localStorage.getItem("companyMail") ? (
              <form className="order-page-container">
                <div className="order-left-side">
                  <h3> Sipariş Girdileri </h3>

                  <div
                    className={"order-left-side-content " + (this.state.submitClicked ? "load" : "")}>
                    {this.state.submitClicked ? (
                      <div className="submit-loader">
                        <img src={loader} alt="Loader"/>
                      </div>
                    ) : (
                      <span hidden> </span>
                    )}

                    {this.state.isSubmit ? (
                      <div className="submitted-form">
                        <h4> Sipariş başarılı bir şekilde verildi. </h4>
                        <h2> Sipariş Numarası:
                          #{this.state.value === 2 ? (
                            parseInt(this.state.order_id, 10) + parseInt(1, 10)
                          ) : (
                            <span hidden> </span>
                          )}

                          {this.state.value === 3 ? (
                            parseInt(this.state.order_id, 10) + parseInt(1, 10)
                          ) : (
                            <span hidden> </span>
                          )}

                          {this.state.value === 4 ? (
                            parseInt(this.state.order_id, 10) + parseInt(this.state.tualArray.length, 10)
                          ) : (
                            <span hidden> </span>
                          )}

                          {this.state.value === 5 ? (
                            parseInt(this.state.order_id, 10) + parseInt(this.state.photoBlockArray.length, 10)
                          ) : (
                            <span hidden> </span>
                          )}

                          {this.state.value === 6 ? (
                            parseInt(this.state.order_id, 10) + parseInt(this.state.printingArray.length, 10)
                          ) : (
                            <span hidden> </span>
                          )}
                        </h2>

                        <div className="we-transfer">
                          <p className="info">
                            Lütfen sipariş numarasını, göndereceğiniz <b> dosyanın ismi</b> olarak ayarlayıp daha sonrasında wetransferden <b>saydamalbum@gmail.com'a</b> yükleyip gönderiniz.
                          </p>

                          <a href="//wetransfer.com" target="_blank"
                             rel="noopener noreferrer">
                            <RaisedButton
                              label="We Transfer'e Git"
                              backgroundColor="#2c3e50"
                              labelColor="#fff"
                              type="button"
                            />
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <p className="info">
                          Lütfen, aşağıdan ilgili kutucukları doldurup sağ taraftan
                          önizlemesini
                          gerçekleştiriniz.
                          Daha sonra size bir çıktı üretip, wetransfer'e yönlendireceğiz.
                          Açıklama
                          kısmında ürettiğimiz çıktıyı
                          kopyalayıp, wetransfere yapıştırıp dosyalarınızı gönderebilirsiniz.
                        </p>

                        <SelectField
                          floatingLabelText="Sipariş Türü"
                          value={this.state.value}
                          floatingLabelStyle={styles.successColor}
                          onChange={this.handleChange.bind(this)}
                        >
                          <MenuItem value={1} primaryText="Sipariş Türünüzü Seçiniz"/>
                          <MenuItem value={2} primaryText="Panoramik Albüm"/>
                          <MenuItem value={3} primaryText="Okul Albüm"/>
                          <MenuItem value={4} primaryText="Tual"/>
                          <MenuItem value={5} primaryText="Fotoblok"/>
                          <MenuItem value={6} primaryText="Baskı"/>
                        </SelectField>

                        {
                          (this.state.value === 2) ? (
                            <div className="album-content contents">

                              <div className="form-group">
                                <SelectField
                                  id="album-ebat"
                                  floatingLabelText="Albüm Ebatı"
                                  value={this.state.albumEbatValue}
                                  floatingLabelStyle={styles.successColor}
                                  onChange={this.albumEbatChange.bind(this)}
                                >
                                  <MenuItem value={6} primaryText="30x90"/>
                                  <MenuItem value={5} primaryText="30x80"/>
                                  <MenuItem value={3} primaryText="30x70"/>
                                  <MenuItem value={2} primaryText="30x60"/>
                                  <MenuItem value={1} primaryText="30x50"/>
                                  <MenuItem value={0} primaryText="30x45"/>
                                  <MenuItem value={12} primaryText="25x70"/>
                                  <MenuItem value={14} primaryText="25x60"/>
                                  <MenuItem value={13} primaryText="25x50"/>
                                  <MenuItem value={9} primaryText="25x40"/>
                                  <MenuItem value={10} primaryText="25x65"/>
                                  <MenuItem value={11} primaryText="Özel Ebat Belirle"/>
                                </SelectField>
                                
                                {this.state.albumEbatValue === 11 && (
                                  <p>Özel ebat seçtiğiniz için temsilcimizle görüşün lütfen</p>
                                )}
                              </div>


                              {!(this.state.albumEbatValue === 9) ? (
                                <div className="form-group" id="fourInput">
                                  <TextField
                                    type="number"
                                    hintText=""
                                    floatingLabelText={this.state.albumRightEbatValue + " Albüm Adeti"}
                                    floatingLabelStyle={styles.successColor}
                                    onChange={(e) => this.setState({panoramikLength: e.target.value})}
                                  />

                                  {(this.state.albumEbatValue === 11) ? (
                                    <TextField
                                      type="text"
                                      hintText="Sadece rakamları yazın"
                                      floatingLabelText="Özel Ebatı Gir"
                                      onChange={this.specialAlbumDimension.bind(this)}
                                      value={this.state.specialAlbumValue}
                                      floatingLabelStyle={styles.successColor}
                                    />
                                  ) : (
                                    <span hidden> </span>
                                  )}

                                  <TextField
                                    type="number"
                                    hintText="0-10 Arası rakam ile belirtiniz"
                                    floatingLabelText={
                                      "Aile Albümü Adet" + ((this.state.albumEbatValue === 1) ? " - 15x25" : "")
                                      + ((this.state.albumEbatValue === 2) ? " - 15x30" : "")
                                      + ((this.state.albumEbatValue === 4) ? " - 20x50" : "")
                                      + ((this.state.albumEbatValue === 7) ? " - 25x50" : "")
                                      + ((this.state.albumEbatValue === 8) ? " - 20x47" : "")
                                      + ((this.state.albumEbatValue === 10) ? " - 20x50" : "")
                                    }
                                    errorText={familyAlbumErrorMessage}
                                    errorStyle={this.state.familyAlbumError ? styles.errorColor : styles.successColor}
                                    floatingLabelStyle={this.state.familyAlbumError ? styles.errorColor : styles.successColor}
                                    onChange={this.familyAlbumChange.bind(this)}
                                  />

                                  {((this.state.albumEbatValue === 3) && (this.state.familyAlbumVal > 0)) ? (
                                    <div>
                                      <SelectField
                                        id="panoramik-album-ebat"
                                        floatingLabelText="30x70 Aile için Ebat Seçiniz"
                                        value={this.state.panoramikAlbumEbat}
                                        onChange={this.panoramikAlbumEbatChange.bind(this)}
                                      >
                                        <MenuItem value={1}
                                                  primaryText="15x35"/>
                                        <MenuItem value={2}
                                                  primaryText="20x46"/>
                                      </SelectField>
                                    </div>
                                  ) : (
                                    <span></span>
                                  )}

                                  {((this.state.albumEbatValue === 5) && (this.state.familyAlbumVal > 0)) ? (
                                    <div>
                                      <SelectField
                                        id="panoramik-album-ebat2"
                                        floatingLabelText="30x80 Aile için Ebat Seçiniz"
                                        value={this.state.panoramikAlbumEbat2}
                                        onChange={this.panoramikAlbumEbatChange2.bind(this)}
                                      >
                                        <MenuItem value={1}
                                                  primaryText="15x40"/>
                                        <MenuItem value={2}
                                                  primaryText="20x50"/>
                                      </SelectField>
                                    </div>
                                  ) : (
                                    <span></span>
                                  )}

                                  {((this.state.albumEbatValue === 6) && (this.state.familyAlbumVal > 0)) ? (
                                    <div>
                                      <SelectField
                                        id="panoramik-album-ebat3"
                                        floatingLabelText="30x90 Aile için Ebat Seçiniz"
                                        value={this.state.panoramikAlbumEbat3}
                                        onChange={this.panoramikAlbumEbatChange3.bind(this)}
                                      >
                                        <MenuItem value={1}
                                                  primaryText="15x45"/>
                                        <MenuItem value={2}
                                                  primaryText="20x60"/>
                                      </SelectField>
                                    </div>
                                  ) : (
                                    <span></span>
                                  )}
                                </div>
                              ) : (
                                <span></span>
                              )}

                              <div className="form-group">
                                <SelectField
                                  id="album-type"
                                  floatingLabelText="Albüm Türü"
                                  value={this.state.albumValue}
                                  floatingLabelStyle={styles.successColor}
                                  onChange={this.albumValueChange.bind(this)}
                                >
                                  <MenuItem value={1} primaryText="Mat"/>
                                  <MenuItem value={2} primaryText="İpek"/>
                                  <MenuItem value={3} primaryText="Kristal"/>
                                  <MenuItem value={4} primaryText="Parlak"/>                                  
                                </SelectField>
                              </div>

                              <div className="form-group">
                                <TextField
                                  type="number"
                                  floatingLabelText="Sayfa Sayısı"
                                  errorText={pageNumberErrorMessage}
                                  errorStyle={this.state.pageNumberError ? styles.errorColor : styles.successColor}
                                  floatingLabelStyle={this.state.pageNumberError ? styles.errorColor : styles.successColor}
                                  onChange={this.pageNumberChange.bind(this)}
                                />
                              </div>

                              <div className="form-group">
                                <SelectField
                                  id="cover-model"
                                  floatingLabelText="Kapak Modeli"
                                  value={this.state.coverModelValue}
                                  floatingLabelStyle={styles.successColor}
                                  onChange={this.coverValueChange.bind(this)}
                                >
                                  <MenuItem value={1} primaryText="Mat Foto Kapak"/>
                                  <MenuItem value={2} primaryText="Kristal Foto Kapak"/>
                                  <MenuItem value={4} primaryText="Dream Mat Kapak"/>
                                  <MenuItem value={3} primaryText="Bella Plus" disabled={![3, 5, 6, 12, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={5} primaryText="Bella" disabled={![3, 5, 6, 12, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={6} primaryText="Camel" />
                                  <MenuItem value={7} primaryText="Elegance" disabled={![5, 6, 3, 2, 1, 12, 14, 13, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={8} primaryText="Elizabeth" disabled={![2, 5, 6, 3, 12, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={9} primaryText="Emily" disabled={![5, 6, 3, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={10} primaryText="Even" disabled={![5, 6, 3, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={11} primaryText="Flora" disabled={![5, 6, 3, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={12} primaryText="Fotokapak" />
                                  <MenuItem value={13} primaryText="Leinen" disabled={![5, 6, 3, 2, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={14} primaryText="Lima" />
                                  <MenuItem value={15} primaryText="Liva" disabled={![5,6,3, 12, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={16} primaryText="Lowra" disabled={![5, 6, 3, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={17} primaryText="LunaPlus" disabled={[0].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={18} primaryText="Luna" disabled={[0].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={19} primaryText="Magneto" disabled={![2, 13, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={20} primaryText="Marvel" disabled={![5, 6, 3, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={21} primaryText="Medusa" disabled={![5, 6, 3, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={22} primaryText="Montana" disabled={![5, 6, 3, 12, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={23} primaryText="Nubuk" disabled={[9].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={24} primaryText="Rachel" disabled={![5, 6, 3, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={25} primaryText="Reina" disabled={![5, 6, 3, 2, 1, 12, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={26} primaryText="Ruby" disabled={![5, 6, 3, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={27} primaryText="Saha" disabled={![2, 13, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={28} primaryText="September" disabled={![5, 6, 3, 2, 12, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={29} primaryText="Sieana" />
                                  <MenuItem value={30} primaryText="Square" disabled={![1, 5, 6, 3, 2, 12, 13, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={31} primaryText="Straw" disabled={![5, 6, 3,2, 12, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={32} primaryText="Tokyo" disabled={[0].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={33} primaryText="Velvet" disabled={[9].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={34} primaryText="Window Plus" disabled={![2, 5, 6,3,12, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={35} primaryText="Window" disabled={![2, 5, 6, 3, 12, 11].includes(this.state.albumEbatValue)} />
                                  <MenuItem value={36} primaryText="Wood Plus" disabled={[0, 14, 13, 9].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={37} primaryText="Wood" disabled={![1, 2, 5, 6, 3, 11, 12].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={38} primaryText="Root" disabled={![5, 6, 3, 12, 11].includes(this.state.albumEbatValue)}  />
                                  <MenuItem value={39} primaryText="Simple" disabled={[9].includes(this.state.albumEbatValue)}  />
                                </SelectField>

                                <RaisedButton
                                  label="Modeller için Tıklayınız"
                                  backgroundColor="#2c3e50"
                                  labelColor="#fff"
                                  onClick={() => {
                                    let options = 'width=800,height=800,fullscreen=no,toolbar=no,titlebar=no,status=no';
                                    options+= `,left=${(window.outerWidth / 2) - 400},top=${(window.outerHeight / 2 - 400)}`;
                                    window.open(`${process.env.PUBLIC_URL}/urunlerimiz`, '', options);
                                  }}
                                  type="button"
                                />

                                <div className={"picture "}>
                                  <i className="material-icons"
                                     onClick={() => {
                                       this.setState({isPhotoShow: false})
                                     }}
                                  >close</i>
                                  <img src={sfotokapak} alt=""/>
                                </div>
                              </div>

                              {[14, 35, 34, 13, 8, 37, 36, 9, 25, 6, 21, 28, 23, 7, 15, 11, 33, 27, 10, 19, 26, 20, 22, 16, 3, 5, 17, 18, 30, 32, 38, 39].includes(this.state.coverModelValue) && (
                                <div className="form-group">
                                  <TextField
                                    type="text"
                                    hintText="Sadece rakamları yazın"
                                    floatingLabelText="Gelin & Damat & Bebek İsim"
                                    floatingLabelStyle={styles.successColor}
                                    value={this.state.brideName}
                                    onChange={(e) => this.setState({ brideName: e.target.value })}
                                  />

                                  <DatePicker
                                    hintText="Gelin & Damat & Bebek Tarih"
                                    firstDayOfWeek={0}
                                    locale='tr-TR'
                                    okLabel="Tamam"
                                    cancelLabel="İptal"
                                    autoOk="true"
                                    onChange={this.datePickerChange.bind(this)}
                                    DateTimeFormat={ Intl.DateTimeFormat}
                                  />
                                </div>

                              )}

                              <div className="form-group albumRanking">
                                <label htmlFor="albumRanking">
                                  Albüm Sıralama
                                </label>
                                <RadioButtonGroup name="albumRanking" defaultSelected="1" onChange={this.albumRankingChange.bind(this)}>
                                  <RadioButton
                                    value="1"
                                    label="Sıralı"
                                  />
                                  <RadioButton
                                    value="0"
                                    label="Sırasız"
                                  />
                                </RadioButtonGroup>
                              </div>

                              <div className="form-group">
                                <TextField
                                  type="text"
                                  hintText="Sadece rakamları yazın"
                                  floatingLabelText="1-) Baskı(Poster - Ebat)"
                                  floatingLabelStyle={styles.successColor}
                                  value={this.state.albumGiftPhotoValue}
                                  onChange={this.giftPhotoChange.bind(this)}
                                />
                              </div>


                              <div className="form-group">
                                <TextField
                                  type="text"
                                  hintText="Sadece rakamları yazın"
                                  floatingLabelText="1-) Tual(Ebat)"
                                  floatingLabelStyle={styles.successColor}
                                  onChange={this.giftTualChange.bind(this)}
                                  value={this.state.albumGiftTualValue}

                                />
                              </div>

                              <div className="form-group">
                                <TextField
                                  type="text"
                                  hintText="Sadece rakamları yazın"
                                  floatingLabelText="2-) Baskı(Poster - Ebat)"
                                  floatingLabelStyle={styles.successColor}
                                  value={this.state.albumGiftPhotoValue2}
                                  onChange={this.giftPhotoChange2.bind(this)}
                                />
                              </div>


                              <div className="form-group">
                                <TextField
                                  type="text"
                                  hintText="Sadece rakamları yazın"
                                  floatingLabelText="2-) Tual(Ebat)"
                                  floatingLabelStyle={styles.successColor}
                                  onChange={this.giftTualChange2.bind(this)}
                                  value={this.state.albumGiftTualValue2}

                                />
                              </div>


                              <div className="form-group">
                                <TextField
                                  type="text"
                                  hintText="Sadece rakamları yazın"
                                  floatingLabelText="3-) Baskı(Poster - Ebat)"
                                  floatingLabelStyle={styles.successColor}
                                  value={this.state.albumGiftPhotoValue3}
                                  onChange={this.giftPhotoChange3.bind(this)}
                                />
                              </div>


                              <div className="form-group">
                                <TextField
                                  type="text"
                                  hintText="Sadece rakamları yazın"
                                  floatingLabelText="3-) Tual(Ebat)"
                                  floatingLabelStyle={styles.successColor}
                                  onChange={this.giftTualChange3.bind(this)}
                                  value={this.state.albumGiftTualValue3}

                                />
                              </div>


                              <div className="form-group description">
                                <label htmlFor="album-description">
                                  Açıklama
                                </label>

                                <textarea name="" id="" cols="30" rows="10"
                                          onChange={this.descChange.bind(this)}>
                                                    </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }

                        {
                          (this.state.value === 3) ? (
                            <div className="school-content contents">
                              <div className="form-group">
                                <SelectField
                                  id="school-album-ebat"
                                  floatingLabelText="Albüm Ebatı"
                                  value={this.state.schoolAlbumEbatValue}
                                  floatingLabelStyle={styles.successColor}
                                  onChange={this.schoolAlbumEbatChange.bind(this)}
                                >
                                  <MenuItem value={1} primaryText="25x40"/>
                                  <MenuItem value={2} primaryText="30x40"/>
                                  <MenuItem value={3} primaryText="30x45"/>
                                  <MenuItem value={4} primaryText="20x50"/>
                                  <MenuItem value={5} primaryText="20x60"/>
                                  <MenuItem value={6} primaryText="25x50"/>
                                  <MenuItem value={7} primaryText="25x60"/>
                                  <MenuItem value={8}
                                            primaryText="30x50 - (Kelebek Albüm)"/>
                                  <MenuItem value={9}
                                            primaryText="25x40 - (Akordiyon İkili)"/>
                                  <MenuItem value={10}
                                            primaryText="25x60 - (Akordiyon Üçlü)"/>
                                  <MenuItem value={11}
                                            primaryText="25x40 - (Açmalı Kapak)"/>
                                  <MenuItem value={12} primaryText="Takvim"

                                  />
                                </SelectField>
                              </div>

                              {(this.state.schoolAlbumEbatValue === 11) ? (
                                <div>
                                  <div className="form-group">
                                    <TextField
                                      type="text"
                                      hintText="Sadece rakamları giriniz"
                                      floatingLabelText="Takvim Ebatı"
                                      floatingLabelStyle={styles.successColor}
                                      onChange={this.schoolCalendarDimension.bind(this)}
                                      value={this.state.schoolCalendarDimensionValue}
                                    />
                                  </div>

                                  <div className="form-group">
                                    <TextField
                                      type="number"
                                      hintText="Takvim Sayısı"
                                      floatingLabelStyle={styles.successColor}
                                      floatingLabelText="Takvim Sayısı"
                                      onChange={this.schoolCalendarDimensionNumber.bind(this)}
                                    />
                                  </div>
                                </div>
                              ) : (
                                !(this.state.schoolAlbumEbatValue === 8 || this.state.schoolAlbumEbatValue === 9 || this.state.schoolAlbumEbatValue === 10) ? (
                                  <div>
                                    <div className="form-group">
                                      <TextField
                                        type="number"
                                        hintText="0-20 Arası rakam ile belirtiniz"
                                        floatingLabelText="Sayfa Sayısı"
                                        errorText={schoolFamilyAlbumErrorMessage}
                                        errorStyle={this.state.schoolFamilyAlbumError ? styles.errorColor : styles.successColor}
                                        floatingLabelStyle={this.state.schoolFamilyAlbumError ? styles.errorColor : styles.successColor}
                                        onChange={this.schoolFamilyAlbumChange.bind(this)}
                                      />
                                    </div>

                                    <div className="form-group">
                                      <TextField
                                        type="number"
                                        hintText="Öğrenci Adetini Giriniz"
                                        floatingLabelText="Öğrenci Adet"
                                        floatingLabelStyle={styles.successColor}
                                        onChange={(e) => {
                                          this.setState({schoolStudentNumber: e.target.value})
                                        }}
                                      />
                                    </div>
                                  </div>
                                ) : (
                                  <div className="form-group">
                                    <TextField
                                      type="number"
                                      hintText="Öğrenci Adetini Giriniz"
                                      floatingLabelText="Öğrenci Adet"
                                      floatingLabelStyle={styles.successColor}
                                      onChange={(e) => {
                                        this.setState({schoolStudentNumber2: e.target.value})
                                      }}
                                    />
                                  </div>
                                )
                              )}

                              <div className="form-group school-description description">
                                <label htmlFor="school-description">
                                  Açıklama
                                </label>

                                <textarea
                                  name=""
                                  id="school-description"
                                  cols="30"
                                  rows="10"
                                  onChange={(e) => this.setState({schoolDescription: e.target.value})}
                                > </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }

                        {
                          (this.state.value === 4) ? (
                            <div className="tual-content contents">
                              <div className="form-group order-number">
                                <TextField
                                  type="number"
                                  hintText="Sipariş Sayısı (max-20)"
                                  floatingLabelStyle={styles.successColor}
                                  floatingLabelText="Sipariş Sayısı"
                                  onChange={this.tualOrderSize.bind(this)}
                                />
                              </div>

                              {this.state.tualArray}

                              <div className="form-group description">
                                <label htmlFor="tual-description">
                                  Açıklama
                                </label>

                                <textarea
                                  name=""
                                  id="tual-description"
                                  cols="30"
                                  rows="10"
                                  onChange={(e) => this.setState({tualDesc: e.target.value})}
                                > </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }

                        {
                          (this.state.value === 5) ? (
                            <div className="photoPrinting-content contents">

                              <div className="form-group order-number">
                                <TextField
                                  type="number"
                                  hintText="Sipariş Sayısı (max-20)"
                                  floatingLabelStyle={styles.successColor}
                                  floatingLabelText="Sipariş Sayısı"
                                  onChange={this.photoBlockOrderSize.bind(this)}
                                />
                              </div>

                              {this.state.photoBlockArray}

                              <div className="form-group description">
                                <label htmlFor="photoPrinting-description">
                                  Açıklama
                                </label>

                                <textarea
                                  name=""
                                  id="photoPrinting-description"
                                  cols="30"
                                  rows="10"
                                  onChange={(e) => this.setState({photoBlockDesc: e.target.value})}
                                > </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }

                        {
                          (this.state.value === 6) ? (
                            <div className="printing-content contents">
                              <div className="form-group order-number">
                                <TextField
                                  type="number"
                                  hintText="Sipariş Sayısı (max-20)"
                                  floatingLabelStyle={styles.successColor}
                                  floatingLabelText="Sipariş Sayısı"
                                  onChange={this.printingOrderSize.bind(this)}
                                />
                              </div>


                              {this.state.printingArray}

                              <div className="form-group description">
                                <label htmlFor="printing-description">
                                  Açıklama
                                </label>

                                <textarea name=""
                                          id="printing-description"
                                          cols="30"
                                          rows="10"
                                          onChange={(e) => this.setState({printingDesc: e.target.value}) }
                                > </textarea>
                              </div>
                            </div>
                          ) : ("")
                        }
                      </div>
                    )}


                  </div>
                </div>


                {/*Right*/}

                <div className="order-right-side">
                  <h3> Sipariş Önizleme </h3>

                  <div className="order-right-side-content">
                    {(this.state.value === 2) ? (
                      <ul>
                        <li>
                          <strong> Sipariş Türü: </strong>
                          <span>
                                                {this.state.orderType}
                                            </span>
                        </li>

                        <li>
                          <strong> Albüm Ebatı: </strong>
                          <span>{this.state.albumRightEbatValue}</span>
                        </li>

                        <li>
                          <strong> Panoramik Albüm Sayısı: </strong>
                          <span>{this.state.panoramikLength}</span>
                        </li>

                        <li>
                          <strong> Aile Albümü: </strong>
                          <span>
                                                {this.state.familyAlbumVal}
                                            </span>
                        </li>

                        <li>
                          <strong> Albüm Türü: </strong>
                          <span>
                                                {this.state.albumRightValue}
                                            </span>
                        </li>

                        <li>
                          <strong> Sayfa Sayısı: </strong>
                          <span>
                                                {this.state.pageNumber}
                                            </span>
                        </li>


                        <li>
                          <strong> Kapak Modeli: </strong>
                          <span>{this.state.coverRightModelValue}</span>
                        </li>

                        <li>
                          <strong> Gelin & Damat & Bebek İsmi: </strong>
                          <span>{this.state.brideName}</span>
                        </li>

                        <li>
                          <strong> Gelin & Damat & Bebek Tarihi: </strong>
                          <span>{this.state.fulldate}</span>
                        </li>

                        <li>
                          <strong> Albüm Sıralama: </strong>
                          <span>
                                                {this.state.albumRankingValue}
                                            </span>
                        </li>


                        <li>
                          <strong> Baskı: </strong>
                          <span>
                                                {this.state.albumGiftPhotoValue}
                                            </span>
                        </li>

                        <li>
                          <strong> Tual: </strong>
                          <span>
                                                {this.state.albumGiftTualValue}
                                            </span>
                        </li>

                        <li>
                          <strong> Baskı(2): </strong>
                          <span>
                                                {this.state.albumGiftPhotoValue2}
                                            </span>
                        </li>

                        <li>
                          <strong> Tual(2): </strong>
                          <span>
                                                {this.state.albumGiftTualValue2}
                                            </span>
                        </li>

                        <li>
                          <strong> Baskı(3): </strong>
                          <span>
                                                {this.state.albumGiftPhotoValue3}
                                            </span>
                        </li>

                        <li>
                          <strong> Tual(3): </strong>
                          <span>
                                                {this.state.albumGiftTualValue3}
                                            </span>
                        </li>

                        <li>
                          <strong> Açıklama: </strong>
                          <span>
                                                {this.state.albumDescription}
                                            </span>
                        </li>
                      </ul>
                    ) : (
                      <span hidden> </span>
                    )}

                    {(this.state.value === 3) ? (
                      (this.state.schoolAlbumEbatValue === 11) ? (
                        <ul>
                          <li>
                            <strong> Sipariş Türü: </strong>
                            <span> {this.state.orderType} </span>
                          </li>

                          <li>
                            <strong> Albüm: </strong>
                            <span>{this.state.schoolAlbumEbatRightValue}</span>
                          </li>

                          <li>
                            <strong> Takvim Ebatı: </strong>
                            <span> {this.state.schoolCalendarDimensionValue} </span>
                          </li>

                          <li>
                            <strong> Takvim Sayısı: </strong>
                            <span> {this.state.schoolCalendarDimensionNumber} </span>
                          </li>

                          <li>
                            <strong> Açıklama: </strong>
                            <span> {this.state.schoolDescription} </span>
                          </li>
                        </ul>
                      ) : (
                        !(this.state.schoolAlbumEbatValue === 8 || this.state.schoolAlbumEbatValue === 9 || this.state.schoolAlbumEbatValue === 10) ? (
                          <ul>
                            <li>
                              <strong> Sipariş Türü: </strong>
                              <span> {this.state.orderType} </span>
                            </li>

                            <li>
                              <strong> Albüm Ebatı: </strong>
                              <span>{this.state.schoolAlbumEbatRightValue}</span>
                            </li>

                            <li>
                              <strong> Sayfa Sayısı: </strong>
                              <span> {this.state.schoolFamilyAlbumVal} </span>
                            </li>

                            <li>
                              <strong> Öğrenci Adeti: </strong>
                              <span>{this.state.schoolStudentNumber}</span>
                            </li>

                            <li>
                              <strong> Açıklama: </strong>
                              <span> {this.state.schoolDescription} </span>
                            </li>
                          </ul>
                        ) : (
                          <ul>
                            <li>
                              <strong> Sipariş Türü: </strong>
                              <span> {this.state.orderType} </span>
                            </li>

                            <li>
                              <strong> Albüm Ebatı: </strong>
                              <span>{this.state.schoolAlbumEbatRightValue}</span>
                            </li>

                            <li>
                              <strong> Öğrenci Adeti: </strong>
                              <span>{this.state.schoolStudentNumber2}</span>
                            </li>

                            <li>
                              <strong> Açıklama: </strong>
                              <span> {this.state.schoolDescription} </span>
                            </li>
                          </ul>
                        ))
                    ) : (
                      <span hidden> </span>
                    )}

                    {(this.state.value === 4) ? (
                      <ul>
                        <li>
                          <strong> Sipariş Türü: </strong>
                          <span> {this.state.orderType} </span>
                        </li>

                        { Object.keys(this.state.tualObj).map((item, i) => (
                          <li key={i}>
                            <strong>{"(" + (i + 1) + ")" } Tual Ebatı </strong>
                            <span>{this.state.tualObj[item].ebatValue + " - " + this.state.tualObj[item].tualNumber + " Adet"}</span>
                          </li>
                        ))}

                        <li>
                          <strong> Açıklama: </strong>
                          <span> {this.state.tualDesc} </span>
                        </li>
                      </ul>
                    ) : (
                      <span hidden> </span>
                    )}

                    {(this.state.value === 5) ? (
                      <ul>
                        <li>
                          <strong> Sipariş Türü: </strong>
                          <span> {this.state.orderType} </span>
                        </li>

                        { Object.keys(this.state.photoBlockObj).map((item, i) => (
                          <li key={i}>
                            <strong>{"(" + (i + 1) + ")" } Fotoblok Ebatı </strong>
                            <span>{this.state.photoBlockObj[item].ebatValue + " - " + this.state.photoBlockObj[item].photoBlockNumber + " Adet"}</span>
                          </li>
                        ))}

                        <li>
                          <strong> Açıklama: </strong>
                          <span> {this.state.photoBlockDesc} </span>
                        </li>

                      </ul>
                    ) : (
                      <span hidden> </span>
                    )}

                    {(this.state.value === 6) ? (
                      <ul>
                        <li>
                          <strong> Sipariş Türü: </strong>
                          <span> {this.state.orderType} </span>
                        </li>

                        { Object.keys(this.state.printingObj).map((item, i) => (
                          <li key={i}>
                            <strong>{"(" + (i + 1) + ")" } Baskı Ebatı </strong>
                            <span>{this.state.printingObj[item].ebatValue + " - " + this.state.printingObj[item].printingNumber + " Adet"}</span>
                          </li>
                        ))}

                        <li>
                          <strong> Açıklama: </strong>
                          <span> {this.state.printingDesc} </span>
                        </li>

                      </ul>
                    ) : (
                      <span hidden> </span>
                    )}
                  </div>

                  <div className="buttons">
                    <RaisedButton
                      label="Geri"
                      backgroundColor="#2c3e50"
                      labelColor="#fff"
                      type="button"
                      onClick={this.backOrder.bind(this)}
                      disabled={this.state.backButtonError}
                    />

                    <RaisedButton
                      label="Siparişi Tamamla"
                      backgroundColor="#2c3e50"
                      labelColor="#fff"
                      onClick={this.orderSubmit.bind(this)}
                      type="button"
                      disabled={(this.state.value === 1) || (this.state.orderGiven)}
                    />
                  </div>

                </div>
              </form>
            ) : (
              <div className="warning-alert">
                <i className="material-icons">warning</i>
                Lütfen üye girişi yapınız..
              </div>
            )}
          </div>
        </main>

        <Snackbar
          open={this.state.open}
          message={this.state.submitMessage}
          autoHideDuration={2000}
          onRequestClose={this.snackbarClose}
        />

        <Footer />
      </div>
    );
  }
}


export default Order;




// WEBPACK FOOTER //
// ./src/components/giveorder.js